export default function About() {
  return (
    <section id="about" className="py-20 px-20 bg-[#161616] max-w-[1440px] mx-auto">
      <div className="grid grid-cols-2 gap-20">
        <div>
          <p className="text-[11px] uppercase tracking-[2px] font-light text-[#C9A961] mb-6">
            ABOUT SKARPE AS
          </p>
          
          <h2 className="text-[58px] leading-tight font-serif text-white mb-2">
            Team of Experts
          </h2>
          <h3 className="text-[54px] leading-tight font-serif italic text-white/90 mb-16">
            Developing Excellence
          </h3>
          
          <div className="space-y-8 max-w-[520px]">
            <p className="text-[17px] leading-relaxed text-[#A0A0A0]">
              At Skarpe AS, we are passionate about creating innovative iOS applications that make a real difference in users' daily lives. Our team combines deep technical expertise with a user-centric approach to deliver products that are both powerful and intuitive.
            </p>
            
            <p className="text-[17px] leading-relaxed text-[#A0A0A0]">
              With years of experience in mobile development, we understand the unique challenges and opportunities of the iOS platform. Every line of code we write is crafted with precision, ensuring optimal performance, security, and user satisfaction.
            </p>
            
            <p className="text-[17px] leading-relaxed text-[#A0A0A0]">
              Our commitment to excellence drives us to continuously innovate and improve. We stay at the forefront of iOS development trends, adopting the latest technologies and best practices to deliver applications that exceed expectations.
            </p>
          </div>
        </div>
        
        <div>
          <div className="flex items-center gap-3 mb-10">
            <h4 className="text-[28px] font-serif text-white">Our Approach</h4>
            <i className="ri-arrow-right-up-line text-[#C9A961] text-xl"></i>
          </div>
          
          <div className="space-y-6">
            <div className="w-full h-40 rounded-[20px] overflow-hidden relative group">
              <img 
                src="https://public.readdy.ai/ai/img_res/b8da72f48adbee00d839a8f9a20839fa.jpg"
                alt="User-Centric Approach"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-4 left-4 bg-white rounded-xl px-4 py-2">
                <span className="text-sm font-medium text-black">User-Centric</span>
              </div>
            </div>
            
            <div className="grid grid-cols-2 gap-6">
              <div className="h-40 rounded-[20px] overflow-hidden relative group">
                <img 
                  src="https://readdy.ai/api/search-image?query=innovation%20and%20technology%20concept%20with%20futuristic%20iOS%20development%20tools%2C%20modern%20coding%20environment%2C%20abstract%20tech%20visualization%2C%20clean%20workspace%20with%20Apple%20devices%2C%20professional%20software%20engineering%20setup%2C%20contemporary%20design&width=300&height=200&seq=approach-innovation-001&orientation=squarish"
                  alt="Innovation Focus"
                  className="w-full h-full object-cover"
                />
                <div className="absolute bottom-4 left-4 bg-white rounded-xl px-4 py-2">
                  <span className="text-sm font-medium text-black">Innovation</span>
                </div>
              </div>
              
              <div className="h-40 rounded-[20px] overflow-hidden relative group">
                <img 
                  src="https://readdy.ai/api/search-image?query=quality%20assurance%20and%20testing%20in%20iOS%20development%2C%20meticulous%20code%20review%20process%2C%20professional%20software%20quality%20control%2C%20modern%20tech%20workspace%2C%20attention%20to%20detail%2C%20clean%20organized%20environment%20with%20Apple%20technology&width=300&height=200&seq=approach-quality-001&orientation=squarish"
                  alt="Quality Assurance"
                  className="w-full h-full object-cover"
                />
                <div className="absolute bottom-4 left-4 bg-white rounded-xl px-4 py-2">
                  <span className="text-sm font-medium text-black">Quality</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
